export default {"src":"/_next/static/media/positionOpposition.71c8f253.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};